import { ReactNode } from 'react';

import { MagritteNotificationName } from 'utils/constants/notification';

import CopySuccess from 'components/Notifications/components/CopySuccess';

import { MagritteNotificationType } from 'store/models/notification';

export interface NotificationItem {
    type: MagritteNotificationType;
    trl?: string;
    dataQa?: string;
    showClose?: boolean;
    autohideTime?: number;
    additionalContent?: ReactNode;
    description?: string;
}

type NotificationConfig = {
    [key in MagritteNotificationName]: NotificationItem;
};

export const NOTIFICATION_CONFIG: NotificationConfig = {
    [MagritteNotificationName.SomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'somethingWentWrong.notification.title',
    },
    [MagritteNotificationName.AiImageGenerationSomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.generation.modal.error.somethingWentWrong',
    },
    [MagritteNotificationName.AuctionBuilderCreateSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'AuctionBuilder.notification.createSuccess',
    },
    [MagritteNotificationName.AuctionBuilderDuplicatedCampaignError]: {
        type: MagritteNotificationType.Error,
        trl: 'AuctionBuilder.notification.error.duplicatedCampaignError',
    },
    [MagritteNotificationName.AuctionBuilderLowBalanceError]: {
        type: MagritteNotificationType.Error,
        trl: 'AuctionBuilder.notification.error.lowBalanceError',
    },
    [MagritteNotificationName.AuctionBuilderSaveSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'AuctionBuilder.notification.saveSuccess',
    },
    [MagritteNotificationName.AuctionBuilderSomethingWentWrongError]: {
        type: MagritteNotificationType.Error,
        trl: 'AuctionBuilder.notification.error.somethingWentWrongError',
    },
    [MagritteNotificationName.AuctionBuilderValidationError]: {
        type: MagritteNotificationType.Error,
        trl: 'AuctionBuilder.notification.error.validationError',
    },
    [MagritteNotificationName.CampaignFormDefaultImagesError]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.DefaultImages.notification.somethingWentWrong',
    },
    [MagritteNotificationName.BalanceRefundError]: {
        type: MagritteNotificationType.Error,
        trl: 'Header.HeaderBalanceDrop.AdditionalActions.refund.error',
    },
    [MagritteNotificationName.BalanceRefundSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'Header.HeaderBalanceDrop.AdditionalActions.refund.success',
    },
    [MagritteNotificationName.CampaignMultiBudgetIncreaseError]: {
        type: MagritteNotificationType.Error,
        trl: 'dashboard.campaign.actions.multiBudgetIncrease.notification.error',
    },
    [MagritteNotificationName.CampaignsReportError]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.campaignsReport.error',
    },
    [MagritteNotificationName.MultiCreationAuctionIncorrectCount]: {
        type: MagritteNotificationType.Error,
        trl: 'MultiCreationAuction.VacanciesTable.error.incorrectCount',
    },
    [MagritteNotificationName.MultiCreationAuctionUnknownError]: {
        type: MagritteNotificationType.Error,
        trl: 'MultiCreationAuction.VacanciesTable.error.unkownError',
    },
    [MagritteNotificationName.MultiCreationAuctionValidationError]: {
        type: MagritteNotificationType.Error,
        trl: 'MultiCreationAuction.error.validationError',
    },
    [MagritteNotificationName.CampaignCopySuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'campaign.copy.success',
        additionalContent: <CopySuccess />,
    },
    [MagritteNotificationName.CampaignStatisticCardSomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'CampaignStatisticCard.somethingWentWrong.error',
    },
    [MagritteNotificationName.CopiedToClipboard]: {
        type: MagritteNotificationType.Success,
        trl: 'copiedToClipboard',
    },
    [MagritteNotificationName.BannerModerationInfoSomethingWentWrongError]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.bannerModerationInfo.error.somethingWentWrong',
    },
    [MagritteNotificationName.RequisitesFormValidationError]: {
        type: MagritteNotificationType.Error,
        trl: 'RequisitesForm.validationErrorNotification',
    },
    [MagritteNotificationName.RequisitesSaveForbiddenError]: {
        type: MagritteNotificationType.Error,
        trl: 'RequisitesForm.forbidden.notification',
    },
    [MagritteNotificationName.RequisitesSaveSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'RequisitesForm.success.notification',
    },
    [MagritteNotificationName.CreateQuickCampaignSaveSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'create.quick.campaign.save.success',
    },
    [MagritteNotificationName.CreateQuickCampaignValidationError]: {
        type: MagritteNotificationType.Error,
        trl: 'create.quick.campaign.validation.error',
    },
    [MagritteNotificationName.CreateQuickCampaignRegionUnavailableError]: {
        type: MagritteNotificationType.Error,
        trl: 'create.quick.campaign.regionUnavailable.error',
    },
    [MagritteNotificationName.CreateQuickCampaignAreaUnavailableError]: {
        type: MagritteNotificationType.Error,
        trl: 'create.quick.campaign.areaUnavailable.error',
    },
    [MagritteNotificationName.CreateQuickCampaignSomethingWentWrongError]: {
        type: MagritteNotificationType.Error,
        trl: 'create.quick.campaign.somethingWentWrong.error',
    },
    [MagritteNotificationName.CropModalRequiredImagesError]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.CropImage.requiredImagesError',
    },
    [MagritteNotificationName.ErrorAccessInBannerLink]: {
        type: MagritteNotificationType.Error,
        trl: 'errorAccessInBannerLink.notification.title',
        description: 'errorAccessInBannerLink.notification.text',
    },
    [MagritteNotificationName.ErrorVacancyInBannerLink]: {
        type: MagritteNotificationType.Error,
        trl: 'errorVacancyInBannerLink.notification.title',
        description: 'errorVacancyInBannerLink.notification.text',
    },
    [MagritteNotificationName.ErrorUrlInBannerLink]: {
        type: MagritteNotificationType.Error,
        trl: 'errorUrlInBannerLink.notification.title',
        description: 'CampaignCreationWizard.VacancySelectStep.website.errorInvalidUrl',
    },
    [MagritteNotificationName.SaveImageToGallerySomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.saveImageToGallery.error',
    },
    [MagritteNotificationName.SaveImageToGallerySuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'AdCreate.AdForm.BannerImg.saveImageToGallery.success',
    },
    [MagritteNotificationName.BannerTextGenerationSomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerText.generation.error.somethingWentWrong',
    },
    [MagritteNotificationName.CreateCampaignSomethingWentWrongError]: {
        type: MagritteNotificationType.Error,
        trl: 'create.campaign.somethingWentWrong.error',
    },
    [MagritteNotificationName.CreateBannerSomethingWentWrongError]: {
        type: MagritteNotificationType.Error,
        trl: 'create.banner.somethingWentWrong.error',
    },
    [MagritteNotificationName.CampaignFormFieldsError]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.Fields.errorMagritte',
    },
    [MagritteNotificationName.CampaignFormImageTooBigSize]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.bitSize',
    },
    [MagritteNotificationName.CampaignFormImageWrongExtension]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.wrongExtension',
    },
    [MagritteNotificationName.CampaignFormImageTooHighResolution]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.highResolution',
    },
    [MagritteNotificationName.CampaignFormImageTooLowResolution]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.lowResolution',
    },
    [MagritteNotificationName.CampaignFormImageTooLowResolutionForSources]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.lowResolutionForSources',
    },
    [MagritteNotificationName.CampaignFormImageSomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.somethingWentWrong',
    },
    [MagritteNotificationName.CampaignFormImageUnableToCropImage]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerImg.notification.lowResolutionForSources',
    },
    [MagritteNotificationName.CampaignFormVideoTooBigSize]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.bitSize',
    },
    [MagritteNotificationName.CampaignFormVideoTooLongDuration]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.bitDuration',
    },
    [MagritteNotificationName.CampaignFormVideoTooShortDuration]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.lowDuration',
    },
    [MagritteNotificationName.CampaignFormVideoWrongResolution]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.wrongResolution',
    },
    [MagritteNotificationName.CampaignFormVideoSomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.somethingWentWrong',
    },
    [MagritteNotificationName.CampaignFormVideoWrongFormat]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.wrongFormat',
    },
    [MagritteNotificationName.CampaignFormVideoErrorWhileProcess]: {
        type: MagritteNotificationType.Error,
        trl: 'AdCreate.AdForm.BannerVideo.notification.errorWhileProcess',
    },
    [MagritteNotificationName.PromoCodeAlreadyUsed]: {
        type: MagritteNotificationType.Error,
        trl: 'BalanceAndBonuses.PromoCodeCard.error.alreadyUsed',
    },
    [MagritteNotificationName.PromoCodeFailed]: {
        type: MagritteNotificationType.Error,
        trl: 'BalanceAndBonuses.PromoCodeCard.error.failed',
    },
    [MagritteNotificationName.PromoCodeActivationError]: {
        type: MagritteNotificationType.Error,
        trl: 'BalanceAndBonuses.PromoCodeCard.error.activationError',
    },
    [MagritteNotificationName.ReportDownloadError]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.report.DownloadError',
    },
    [MagritteNotificationName.AdminStopPromoCodeError]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.promoCodes.stopPromoCode.error',
    },
    [MagritteNotificationName.AdminCreatePromoCodeSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'admin.promoCodes.createPromoCode.success',
    },
    [MagritteNotificationName.AdminCreatePromoCodeError]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.promoCodes.createPromoCode.error',
    },
    [MagritteNotificationName.AdminUpdatePromoCodeSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'admin.promoCodes.updatePromoCode.success',
    },
    [MagritteNotificationName.AdminUpdatePromoCodeError]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.promoCodes.updatePromoCode.error',
    },
    [MagritteNotificationName.AdminCreateOrUpdatePromoCodeValidationError]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.promoCodes.createOrUpdatePromoCode.validation.error',
    },
    [MagritteNotificationName.AdminCreatePromoCodeDuplicationError]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.promoCodes.createPromoCode.duplication.error',
    },
    [MagritteNotificationName.ImageUpscaleSomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'BannerImg.CropImageModal.ImageContent.upscaleError.upscale',
    },
    [MagritteNotificationName.ImageUpscaleInfoSomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'BannerImg.CropImageModal.ImageContent.upscaleError.info',
    },
    [MagritteNotificationName.BalanceReBalanceSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'Header.HeaderBalanceDrop.AdditionalActions.reBalance.success',
    },
    [MagritteNotificationName.BalanceReBalanceError]: {
        type: MagritteNotificationType.Error,
        trl: 'Header.HeaderBalanceDrop.AdditionalActions.reBalance.error',
    },
    [MagritteNotificationName.CampaignArchiveError]: {
        type: MagritteNotificationType.Error,
        trl: 'campaign.info.sudo.actions.archiveCampaign.error',
    },
    [MagritteNotificationName.CampaignChangeStatusToArchiveSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'dashboard.campaign.actions.updateCampaignStatus.archive',
    },
    [MagritteNotificationName.SubscriptionSettingsSaveSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'Settings.Notification.success',
    },
    [MagritteNotificationName.SubscriptionSettingsSaveError]: {
        type: MagritteNotificationType.Error,
        trl: 'Settings.Notification.error',
    },
    [MagritteNotificationName.LinkCopyToClipboardSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'linkCopyToClipboard.success',
    },
    [MagritteNotificationName.VacancyIdCopyToClipboardSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'vacancyIdCopyToClipboardSuccess.success',
    },
    [MagritteNotificationName.AdQuickCreateWithForeignArea]: {
        type: MagritteNotificationType.Error,
        trl: 'AdQuickCreate.notification.AdQuickCreateWithForeignArea',
    },
    [MagritteNotificationName.CampaignChangeStatusToActiveSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'updateCampaignStatus.notification.activeSuccess',
    },
    [MagritteNotificationName.CampaignChangeStatusToActiveAndMoveSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'updateCampaignStatus.notification.activeAndMoveSuccess',
    },
    [MagritteNotificationName.CampaignChangeStatusToPausedSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'updateCampaignStatus.notification.pausedSuccess',
    },
    [MagritteNotificationName.CampaignChangeStatusToPausedAndMoveSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'updateCampaignStatus.notification.pausedAndMoveSuccess',
    },
    [MagritteNotificationName.CampaignChangeStatusToArchivedSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'updateCampaignStatus.notification.archivedSuccess',
    },
    [MagritteNotificationName.CampaignChangeStatusToArchivedAndMoveSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'updateCampaignStatus.notification.archivedAndMoveSuccess',
    },
    [MagritteNotificationName.CampaignChangeStatusFailed]: {
        type: MagritteNotificationType.Error,
        trl: 'updateCampaignStatus.notification.changeStatusFailed',
    },
    [MagritteNotificationName.CampaignBudgetIncreaseTotalFailed]: {
        type: MagritteNotificationType.Error,
        trl: 'BudgetIncreaseModal.notification.totalFailed',
    },
    [MagritteNotificationName.CampaignBudgetIncreasePartialFailed]: {
        type: MagritteNotificationType.Error,
        trl: 'BudgetIncreaseModal.notification.partialFailed',
    },
    [MagritteNotificationName.CampaignMultiChangeStatusToBlockedError]: {
        type: MagritteNotificationType.Error,
        trl: 'CampaignsMultiActionsPanel.notification.multiStopError',
    },
    [MagritteNotificationName.VrCampaignRequestSuccess]: {
        type: MagritteNotificationType.Success,
        trl: 'VrCampaignBuilder.notification.requestSuccess',
    },
    [MagritteNotificationName.UsersPageErrorEmptyValue]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.Users.Filter.notification.emptyValue',
    },
    [MagritteNotificationName.UsersPageErrorSomethingWentWrong]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.Users.notification.somethingWentWrong',
    },
    [MagritteNotificationName.UsersPageUpdateUserData]: {
        type: MagritteNotificationType.Success,
        trl: 'admin.UserDetail.EditUserForm.notification',
    },
    [MagritteNotificationName.UsersPageErrorUpdateUserData]: {
        type: MagritteNotificationType.Error,
        trl: 'admin.UserDetail.EditUserForm.notification.error',
    },
    [MagritteNotificationName.DownloadStatisticError]: {
        type: MagritteNotificationType.Error,
        trl: 'dashboard.title.downloadStatistic.error.text',
    },
};
